import { RootState } from "@/services/state/store";
import { Box, HStack, Icon, Text } from "@chakra-ui/react";
import { IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";

export const ProcessDesignerBar = () => {
  const selectedProcessModel = useSelector(
    (state: RootState) => state.processes.selectedProcess
  );

  const handleClose = () => {
    window.close();
  };

  return (
    <Box
      bg="rgba(255, 255, 255, 0.05)"
      backdropFilter="blur(20px)"
      border="1px solid rgba(255, 255, 255, 0.4)"
      // borderRadius="12px"
      borderBottomRadius="12px"
      width={"100%"}
      p={2}
      minHeight="40px"
      display="flex"
      alignItems="center"
    >
      <HStack>
        <HStack
          border={"1px"}
          borderWidth={"1px"}
          p={2}
          background="linear-gradient(to right, #7652f7, #9500ff)"
          borderColor="rgba(255, 255, 255, 0.2)"
          borderRadius={"md"}
          minWidth={"15%"}
          justifyContent={"space-between"}
          boxShadow="0 4px 12px rgba(118, 82, 247, 0.3)"
        >
          <Text color={"white"} fontWeight="semibold">
            {selectedProcessModel?.processNm}
          </Text>
          <Icon
            as={IoClose as React.ElementType}
            color={"white"}
            cursor={"pointer"}
            onClick={handleClose}
            _hover={{ color: "red.300" }}
            transition="color 0.2s ease"
          />
        </HStack>
      </HStack>
    </Box>
  );
};
